module.exports = __webpack_public_path__ + "img/16_102.2b5884b7.png";